import { NativeDateAdapter } from '@angular/material/core';
import { Injectable } from '@angular/core';

@Injectable()
export class CustomTimeAdapter extends NativeDateAdapter {

  override format(date: Date): string {
    const hours = this.convertToTwoSymbols(date.getHours());
    const minutes = this.convertToTwoSymbols(date.getMinutes());

    return `${hours}:${minutes}`;
  }

  override parse(value: any): Date | null {
    if (!value) {
      return null;
    }

    if (typeof value === 'string') {
      const timeMatch = value.match(/^(\d{1,2})[:.](\d{2})$/);

      if (timeMatch) {
        const hours = parseInt(timeMatch[1], 10);
        const minutes = parseInt(timeMatch[2], 10);

        if (hours >= 0 && hours <= 23 && minutes >= 0 && minutes <= 59) {
          const now = new Date();
          return new Date(now.getFullYear(), now.getMonth(), now.getDate(), hours, minutes, 0, 0);
        }
      }
    }

    return super.parse(value);
  }

  private convertToTwoSymbols(value: number): string {
    return value.toString().padStart(2, '0');
  }
}
